import React, { useEffect, useState } from 'react';
import Button from '../../../components/controls/button';
import Style from './ForgotPassword.module.css';
import { useHistory } from 'react-router';
import { isValidEmail } from '../../../utils/formValidation';
import { useSelector } from 'react-redux';
import { loginInProgress } from '../../../store/selectors/auth.selector';
import CustomInput from "../../../components/controls/input/customInput/CustomInput";
import HanshiWhiteLogo from '../../../assets/hanshi/full-white-sm.svg';
import { ArrowLeft } from "../../../modules/default-svg";
import { getDecryptedCookie } from '../../../utils/cookieUtils';

const ForgotPassword = (props) => {
  const { forgotPasswordRequest, resetErrorMesage } = props;
  const domain = getDecryptedCookie("domain");
  const history = useHistory();

  const isLoading = useSelector(loginInProgress);

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    resetErrorMesage();
    if(!domain){
      history.push('/');
    }
  }, []);

  const handleSendMail = async () => {
    if (isLoading)
      return;

    if(!isValidEmail(email) ){
      setEmailError("Invalid Email");
        return;
    }

  
    forgotPasswordRequest({
      payload:{
        email: email,
      },
      domain: domain
    });

    history.push('/email-confirmation');
  };

  const handleBack = async () => {
    history.push('/')
  };

  const handleEmailChange = (email) =>{
    setEmail(email);
    setEmailError("");
  }

  return (
    <div className={Style.mainWrapper}>
      <div className={Style.card}>
        <div className="w-full flex justify-center pt-10 mb-5">
          <img src={HanshiWhiteLogo} alt="Hanshi Logo" className="w-32 md:w-48" />
        </div>
        <div className={Style.cardContent}>
          <div className={Style.cardTitleContainer}>
            <p className={`${Style.cardTitle} text-xl-700`}>Forgot password?</p>
            <p className={`${Style.cardDescription} text-sm-500`}>We'll send a recovery link to your email</p>
          </div>
          <div>
            <div className={Style.emailFieldWrapper}>
              <CustomInput
                      inputClass={Style.emailInput}
                      labelClass={Style.emailLabel}
                      isRequired
                      icon={false}
                      label="Email"
                      type="email"
                      errorMessage={emailError}
                      handleChange={handleEmailChange}
                    />
            </div>
          </div>
        </div>
        <div className={Style.btnWrapper}>
          <Button btnClass="btn_w100 btn_w100_primary" label="Submit" cssClass={`${Style.sendMailBtn}`} clickHandler={handleSendMail} showLoading={isLoading} isDisabled={email == ''} />
          <div className="d-flex align-items-center">
              <ArrowLeft />
              <p className="my-3 text-xsm-500 text-[#5e5e5e] hover:text-[#342c82] hover:cursor-pointer" onClick={handleBack}>
                  Back to Sign In
              </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;